'use client';

import type {
  CategoriesEntity,
  GeneralLayout,
  Menu,
} from '@eliadmin/core/src/api/general/types/general-layout-types';

import { MobileMenuProvider } from '@eliadmin/core/src/components/header/menu-mobile';
import { Topbar } from './topbar';
import { HeaderMain } from './header-main';
import { BottomBar } from '@eliadmin/core/src/components/homepage/bottom-bar';
import { usePathname } from 'next/navigation';
import { ROUTES } from '../../constants/routes';
import { CartHeader } from './cart-header';

interface HeaderClientProps {
  generalLayout: GeneralLayout['data'];
  categories: CategoriesEntity[];
  menu: Menu[];
}

export function HeaderClient({ generalLayout, categories, menu }: HeaderClientProps) {
  const pathname = usePathname();

  const isCart = pathname === ROUTES.CART();

  if (isCart) {
    return <CartHeader generalLayout={generalLayout} />;
  }

  return (
    <MobileMenuProvider>
      <Topbar generalLayout={generalLayout} menu={menu[0]} />
      <div className="sticky left-0 top-0 z-40 w-full border-b border-b-border">
        <HeaderMain categories={categories} generalLayout={generalLayout} menu={menu[0]} />
      </div>
      <BottomBar />
    </MobileMenuProvider>
  );
}
